import { JwtAxios } from '@/packaging';

export const paymentAPI = {

  GetNowPayment: async () => {
    const res = await JwtAxios.get(
      '/Payment/GetNowPayment'
    );
    return res;
  },
  GetPeriodList: async () => {
    const res = await JwtAxios.get('/Payment/GetPeriodList');
    return res;
  },
  GetPackageList:  async () => {
    const res = await JwtAxios.get('/Payment/GetPackageList');
    return res;
  },
  GetMaxProductsList: async () => {
    const res = await JwtAxios.get('/Payment/GetMaxProductsList');
    return res;
  },
  GetMaxAccountsList: async () => {
    const res = await JwtAxios.get('/Payment/GetMaxAccountsList');
    return res;
  },
  GetSourcingList: async (keyword, page, row) => {
    const res = await JwtAxios.get(
      `/Payment/GetSourcingList?keyword=${keyword}&page=${page}&row=${row}`
    );
    return res;
  },
  GetMarketList: async () => {
    const res = await JwtAxios.get('/Payment/GetMarketList');
    return res;
  },
  GetEtcServiceList: async () => {
    const res = await JwtAxios.get('/Payment/GetEtcServiceList');
    return res;
  },
  GetAddSourcingSitePrice: async () => {
    const res = await JwtAxios.get('/Payment/GetAddSourcingSitePrice');
    return res;
  },
  GetSitePriceByValue: async (value) => {
    const res = await JwtAxios.get(`/Payment/GetSitePriceByValue?value=${encodeURIComponent(value)}`);
    return res;
  },
  GetCollectSiteList: async () => {
    const res = await JwtAxios.get('/Payment/GetCollectSiteList');
    return res;
  },
  CreatePaymentId: async body => {
    const res = await JwtAxios.post('/Payment/CreatePaymentId', body);
    return res;
  },
  CreateDepositPaymentId: async body => {
    const res = await JwtAxios.post(`/Payment/CreateDepositPaymentId`, body);
    return res;
  },
  ReturnPayResult: async body => {
    const res = await JwtAxios.post(`/Payment/returnPayResult`, body);
    return res;
  },
  GetPaymentProcessResult: async (paymentId) => {
    const res = await JwtAxios.get(`/Payment/GetInicisPayResult?paymentID=${paymentId}`,);
    return res;
  },
  ProcessOnlineDeposit: async (formData) => {
    const res = await JwtAxios.post('/Payment/ProcessOnlineDeposit', formData);
    return res;
  },
  CreateOnlineDepositPayment: async (body) => {
    const res = await JwtAxios.post('/Payment/CreateOnlineDepositPayment', body);
    return res;
  },
  GetPaymentList: async (page = 1, row = 20) => {
    const res = await JwtAxios.get(`/Payment/GetPaymentList?page=${page}&row=${row}`);
    return res;
  },
  GetPaymentDetail: async (paymentId) => {
    const res = await JwtAxios.get(`/Payment/GetPaymentDetail?paymentId=${paymentId}`);
    return res;
  }
};
